<template>
    <div class="page">
        <div class="users">
            <custom-button v-for="user in users" :key="user.id" v-parse-emojis :disabled="!user.subscription" @click="userId = user.id">{{ user.name }}</custom-button>
        </div>
        <div class="selected-user">
            <p>Notificatie sturen naar</p>
            <p><strong>{{ selectedUser ? selectedUser : 'Kies speler' }}</strong></p>
        </div>
        <div class="input-fields">
            <input v-model="messageTitle" placeholder="Notificatie titel" type="text">
            <textarea v-model="messageBody" placeholder="Notificatie body" type="text"></textarea>
            <input v-model="messageUrl" placeholder="Notificatie url" type="text">
            <input v-model="messageImage" placeholder="Notificatie afbeelding" type="text"></input>
            <custom-button :disabled="disabled" @click="sendMessage">Verstuur</custom-button>
        </div>
        <div class="input-fields" style="margin-top: 24px;">
            <textarea v-model="sql" placeholder="Sql" type="text"></textarea>
            <custom-button :disabled="!sql" @click="sendSql">Uitvoeren</custom-button>
        </div>
    </div>
</template>

<script>
import { httpRequest } from '@/utils.js';
import CustomButton from '@/components/CustomButton.vue';

export default {
    name: '',
    components: {
        CustomButton,
    },
    data() {
        return {
            users: [],
            userId: null,
            messageTitle: '',
            messageBody: '',
            messageUrl: '',
            messageImage: '',
            sql: '',
        }
    },
    methods: {
        sendMessage() {
            httpRequest('POST', '/push/custom', {
                receiverId: this.userId,
                title: this.messageTitle,
                body: this.messageBody,
                image: this.messageImage,
                url: this.messageUrl,
            });
        },
        sendSql() {
            httpRequest('POST', '/sql', {
                sql: this.sql
            });
        }
    },
    computed: {
        selectedUser() {
            const user = this.users.find(user => user.id === this.userId);
            return user? user.name : '';
        },
        disabled() {
            return !this.userId || !this.messageTitle
        }
    },
    async created() {
        this.users = await httpRequest('GET', '/users');
    }
}
</script>

<style lang="scss" scoped>

.page {
    padding: 20px 40px;
    overflow-y: auto;
}

.users {
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 200px;
    overflow-y: auto;
    margin-bottom: 20px;

    .user {
        background: lightgrey;
        padding: 4px 8px;
        border-radius: 8px;

        span {
            white-space: nowrap;
        }

        &.disabled {
            pointer-events: none;
            opacity: 0.5;
        }

        &.active {
            background: green;
        }
    }
}

.selected-user {
    color: white;
    margin-bottom: 20px;
    p {
        font-size: 18px;
        line-height: 24px;
    }
}

.input-fields {
    display: flex;
    flex-direction: column;
    gap: 10px;

    input, textarea {
        padding: 8px 12px;
        border-radius: 8px;
        font-size: 16px;
        border: none;
    }
    button {
        border-radius: 8px;
    }
}

</style>